// extracted by mini-css-extract-plugin
module.exports = {"chat-header":"ChatHeader_chat-header__cQFb2","chat-header__left":"ChatHeader_chat-header__left__OztpZ"};